export const customerSignup = {
  title: 'Ügyfél Regisztráció',
  subtitle: 'Hozd létre a jelszavadat a fiókodhoz',
  
  // Account Info
  accountInfo: {
    title: 'Fiók adatok',
    name: 'Név',
    email: 'Email'
  },
  
  // Form
  form: {
    password: 'Jelszó',
    passwordPlaceholder: 'Minimum 6 karakter',
    confirmPassword: 'Jelszó megerősítése',
    confirmPasswordPlaceholder: 'Jelszó újra',
    createAccount: 'Fiók létrehozása',
    creating: 'Regisztráció...'
  },
  
  // Messages
  messages: {
    passwordTooShort: 'A jelszónak legalább 6 karakter hosszúnak kell lennie',
    passwordMismatch: 'A jelszavak nem egyeznek',
    success: 'Sikeres regisztráció! Átirányítás...',
    emailInUse: 'Ez az email cím már használatban van',
    error: 'Hiba történt a regisztráció során'
  },
  
  // States
  states: {
    loading: 'Betöltés...',
    error: 'Hiba',
    success: 'Sikeres regisztráció!',
    successMessage: 'Fiókod sikeresen létrejött. Átirányítás az ügyfélportálra...'
  },
  
  // Errors
  errors: {
    invalidLink: 'Érvénytelen regisztrációs link',
    expiredLink: 'A regisztrációs link lejárt. Kérj új linket az adminisztrátortól.',
    alreadyHasAccount: 'Már rendelkezel felhasználói fiókkal. Jelentkezz be!',
    validationError: 'Hiba történt a regisztrációs link ellenőrzése során'
  },
  
  // Footer
  footer: {
    hasAccount: 'Már van fiókod?',
    login: 'Bejelentkezés'
  }
};
